import React from "react";
import SingleTripContent from "../components/trips/single-trip-content";

const SingleTrip = () => {
  return <SingleTripContent />;
};

export default SingleTrip;
